import { useQuery } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useGetThreatScoreKey = 'get-threat-score';

export const useGetThreatScore = (enabled: boolean, caseGuid?: string) => {
    const { zoneApiClient } = useZoneContext();
    
    return useQuery({
        queryKey: [useGetThreatScoreKey, caseGuid],
        queryFn: async () => {
            const response = await zoneApiClient.getCaseAssessmentThreatScore(caseGuid ?? '');

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the Threat Scorefor this case.');
            }
            return response.payload;
        },
        enabled: !!caseGuid && enabled,
        cacheTime: Infinity,
        staleTime: Infinity,
    });
};
